import { isData2D } from './isData2D';
export function isSpectrum2D(spectrum) {
    return isData2D(spectrum.data);
}
//# sourceMappingURL=isSpectrum2D.js.map